import { render, staticRenderFns } from "./p295_menu.vue?vue&type=template&id=a9a37998"
import script from "./p295_menu.vue?vue&type=script&lang=js"
export * from "./p295_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HyperLink: require('/root/containers/hermes_eshop/components/core/hyperLink.vue').default})
